import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import Spinner from '../components/Spinner';
import Utils from '../utils/Utils';
import translator from '../theme/translator.json';
import FormPEXBD from './forms/pexbd/FormPEXBD';
import LayoutNoHeader from '../components/LayoutNoHeader';
import { db } from '../FirebaseConfig';
import FormPEXBDV2 from './forms/pexbd_v2/FormPEXBD_V2';
import FormSpecKey, { resolveFormSpecKey } from './forms/pexbd_v2/models/enums/FormSpecKey';
import { isDynamicFormSpecKey } from './forms/pexbd_v2/models/formSpecRegistries';

const FormPage: React.FC = () => {
  const { formId } = useParams();
  const [specKey, setSpecKey] = useState<FormSpecKey | null>(null);

  useEffect(() => {
    try {
      const fetchSpecKey = async () => {
        if (!formId) return;

        const formDocRef = doc(db, 'Forms', formId);
        const formDoc = await getDoc(formDocRef);

        if (formDoc.exists() && formDoc.data().state && formDoc.data().formData) {
          const { formData } = formDoc.data();
          setSpecKey(resolveFormSpecKey(formData));
        }
      };
      fetchSpecKey();
    } catch (e: any) {
      console.error(e);
    }
  }, [formId]);

  const FormComponent = () => {
    if (specKey === FormSpecKey.PEXBD_V1_GROUP1 || specKey === FormSpecKey.PEXBD_V1_GROUP2) {
      return <FormPEXBD formId={formId} />;
    }
    if (isDynamicFormSpecKey(specKey)) return <FormPEXBDV2 formId={formId} specKey={specKey} />;
    return null;
  };

  return (
    <LayoutNoHeader title={Utils.getTranslation(translator.pages.dashboard.title)}>
      <Spinner show={false}/>
      <FormComponent />
    </LayoutNoHeader>

  );
};

export default FormPage;
